import { Component, inject, ViewEncapsulation } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { map, Observable } from 'rxjs';
import { PwaManifestService } from '@madeinlune/ngx-pwa-manifest';
import { DialogRef } from '@angular/cdk/dialog';
import { TranslocoModule } from '@ngneat/transloco';
import { LetDirective } from '@ngrx/component';

@Component({
  selector: 'nx-modulae-update-prompt',
  standalone: true,
  imports: [CommonModule, TranslocoModule, LetDirective],
  template: `

    <ng-container *transloco='let t'>
      <div class='b-icon'>
        <ng-container *ngrxLet='iconUrl$; let iconUrl'>
          <img [src]='iconUrl' />
        </ng-container>
      </div>
      <div class='b-content'>
        <h1 [innerHTML]="t('pwa.update.title')"></h1>
        <p [innerHTML]="t('pwa.update.message')"></p>
      </div>
      <div class='b-actions'>
        <button class='msd-btn outlined' (click)='onCancel()'>
          <span [innerHTML]="t('actions.later')"></span>
        </button>
        <button class='msd-btn contained' (click)='onReload()'>
          <span [innerHTML]="t('actions.reload')"></span>
        </button>
      </div>
    </ng-container>

  `,
  styleUrls: ['./update-prompt.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class UpdatePromptComponent {

  private pwaManifestService = inject(PwaManifestService);
  private dialogRef = inject(DialogRef<any>);
  private document = inject(DOCUMENT);

  readonly iconUrl$: Observable<string | undefined> =
    this.pwaManifestService.icons$.pipe(
      map((icons) => {
        return icons.find((icon) => icon.sizes === '192x192')?.src;
      })
    );

  onReload() {
    if (this.document.defaultView?.location) {
      this.document.defaultView.location.reload();
    }
  }

  onCancel() {
    this.close();
  }

  close() {
    this.dialogRef.close();
  }

}
